import store from '../../store';


export default class loginGuard {
  static routeHasLoginCheckEnabled(to) {
    switch (to.name) {
      case 'LoginPage':
        return false;
      case 'ForgotPassword':
        return false;
      case 'ResetPassword':
        return false;
      case 'DashboardLoginPage':
        return false;
      default:
        return true;
    }
  }

  static noUserDataInTheStore() {
    return store().getters.loginData.userId === '';
  }

  static runGuard(to) {
    return this.routeHasLoginCheckEnabled(to) && this.noUserDataInTheStore();
  }
}
